var escape = require("../../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* ==========================================================================\nMain page styles\n========================================================================== */\n.hipster {\n  display: inline-block;\n  width: 100%;\n  height: 497px;\n  background: url(" + escape(require("../../../static/images/jhipster_family_member_3.svg")) + ") no-repeat center top;\n  background-size: contain;\n}\n", ""]);

// exports
